import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";

// ENG-2482: the CP document pages take the signature on the page, drawn only, as the CP agreement does.
// onChange gets a PNG File after each stroke and null on Clear; `value` (the accepted image) is shown
// when the pad comes back empty, e.g. after Back to edit.
export default function CpSignaturePad({ value, onChange, disabled = false }) {
  const pad = useRef(null);
  const [drawn, setDrawn] = useState(false);
  // react-signature-canvas clears the canvas on every window resize (a phone's URL bar, a rotation); show the accepted
  // image again so the pad never looks blank while a signature is held.
  useEffect(() => {
    const resized = () => setDrawn(false);
    window.addEventListener("resize", resized);
    return () => window.removeEventListener("resize", resized);
  }, []);
  const finish = () => {
    const current = pad.current;
    if (!current || current.isEmpty()) return;
    setDrawn(true);
    current.getCanvas().toBlob((blob) => {
      if (blob) onChange(new File([blob], "signature.png", { type: "image/png" }));
    }, "image/png");
  };
  const clear = () => {
    pad.current?.clear();
    setDrawn(false);
    onChange(null);
  };
  const showSaved = Boolean(value) && !drawn;
  return <div className="space-y-2">
    <div className={`relative h-36 border border-gray-300 rounded bg-white ${disabled ? "pointer-events-none opacity-60" : ""}`}>
      {showSaved ? <img src={value} alt="Your signature" className="absolute inset-0 m-auto max-h-full max-w-full p-2" />
        : <SignatureCanvas ref={pad} penColor="black" onEnd={finish}
          canvasProps={{ className: "block w-full h-full rounded", "aria-label": "Draw your signature" }} />}
    </div>
    <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-gray-600">
      <span>Draw with your mouse or finger.</span>
      <button type="button" className="underline text-purple-700 disabled:opacity-50 disabled:no-underline" disabled={disabled || (!drawn && !value)} onClick={clear}>{showSaved ? "Draw again" : "Clear"}</button>
    </div>
  </div>;
}
